import { Action, createReducer, on } from '@ngrx/store';
import { WithdrawalRequestsWithPagination } from '../../models/api/response/user-management.response';
import { WithdrawalRequestStatusType } from '../../models/withdrawals.interface';
import { BadResponseWithError } from '@shared/models/common.interface';
import { WithdrawalsAction } from '../actions/actions-type.action';

export interface WithdrawalsState {
    withdrawalRequests: WithdrawalRequestsWithPagination | null;
    requestedStatus: WithdrawalRequestStatusType | null | undefined;
    error: BadResponseWithError | null;
    isLoading: boolean;
}

const initialState: WithdrawalsState = {
    withdrawalRequests: null,
    requestedStatus: null,
    error: null,
    isLoading: false,
};

export const reducer = createReducer(
    initialState,
    on(WithdrawalsAction.fetchWithdrawalRequests, (state, action) => ({
        ...state,
        requestedStatus: action.payload?.status,
        isLoading: true,
    })),
    on(WithdrawalsAction.fetchWithdrawalRequestsSuccess, (state, action) => {
        return {
            ...state,
            withdrawalRequests: action.payload.items,
            isLoading: false,
        };
    }),
    on(WithdrawalsAction.fetchWithdrawalRequestsFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    })),
    on(
        WithdrawalsAction.addHashToWithdrawalRequestsSuccess,
        (state, action) => {
            if (!state.withdrawalRequests) {
                return state;
            }

            const updatedItems = state.withdrawalRequests.items.map((item) => {
                if (item.id === action.payload.withdrawalId) {
                    return {
                        ...item,
                        cryptoHashId: action.payload.cryptoHashId,
                    };
                }
                return item;
            });

            return {
                ...state,
                withdrawalRequests: {
                    ...state.withdrawalRequests,
                    items: updatedItems,
                },
                isLoading: false,
            };
        }
    ),
    on(
        WithdrawalsAction.addHashToWithdrawalRequestsFailure,
        (state, action) => ({
            ...state,
            error: action.payload,
            isLoading: false,
        })
    ),
    on(WithdrawalsAction.changeWithdrawalRequestStatus, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(
        WithdrawalsAction.changeWithdrawalRequestStatusSuccess,
        (state, action) => ({
            ...state,
            isLoading: false,
        })
    ),
    on(
        WithdrawalsAction.changeWithdrawalRequestStatusFailure,
        (state, action) => ({
            ...state,
            isLoading: false,
        })
    )

    // on(WithdrawalsAction.signalRWithdrawalRequestAdded, (state, action) => {
    //     let withdrawalRequests = state.withdrawalRequests;
    //
    //     if (
    //         action.payload.request.status ===
    //         WithdrawalRequestStatusType.Pending &&
    //         state.requestedStatus === WithdrawalRequestStatusType.Pending
    //     ) {
    //         withdrawalRequests = {
    //             ...state.withdrawalRequests,
    //             items: [
    //                 action.payload.request,
    //                 ...(
    //                     state.withdrawalRequests as WithdrawalRequestsWithPagination
    //                 ).items,
    //             ],
    //         } as WithdrawalRequestsWithPagination;
    //     }
    //
    //     return {
    //         ...state,
    //         withdrawalRequests,
    //     };
    // }),
    // on(WithdrawalsAction.signalRWithdrawalRequestApproved, (state, action) => ({
    //     ...state,
    // }))
);
export const withdrawalsReducer = (state: WithdrawalsState, action: Action) =>
    reducer(state, action);
